const KEY = 'proteauto_vendedor_id';

export default class VendedorStorage {
  public static get(): number | null {
    const value = localStorage.getItem(KEY);
    return value ? Number(value) : null;
  }

  public static set(id: number) {
    localStorage.setItem(KEY, String(id));
  }

  public static clear() {
    localStorage.removeItem(KEY);
  }
}
